import service from '@/utils/request'; // @Tags BairunSvcOrder
// @Summary 分页获取BairunSvcOrder列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body request.PageInfo true "分页获取BairunSvcOrder列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /bairunSvcConsumeOrder/getBairunSvcConsumeOrderList [get]

export var getBairunSvcConsumeOrderList = function getBairunSvcConsumeOrderList(params) {
  return service({
    url: '/svcManage/svcConsumeOrder/getList',
    method: 'get',
    donNotShowLoading: params.donNotShowLoading ? params.donNotShowLoading : true,
    params: params
  });
};